import {
  Field,
  formValueSelector,
  reduxForm,
  SubmissionError,
} from "redux-form";
import { Button, Input, Checkbox } from "expano-components";
import product_status_options from "utils/select_options/product_status_options";

import { Dashboard, Select } from "components";

import useUpdate from "hooks/useUpdate";
import { connect } from "react-redux";

const InputField = (props) => <Input {...props} />;
const SelectField = (props) => <Select {...props} />;
const CheckField = (props) => <Checkbox {...props} />;

const BasicData = ({
  product_group,
  product_id,
  initialValues,
  product_status,
  is_bundle,
  is_virtual,
  refetch,
  handleSubmit,
  change,
  pristine,
  invalid,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/products/${product_id}`,
    onSuccess: refetch,
    onError: (err) => {
      throw new SubmissionError(
        Object.fromEntries(
          Object.entries(err).map(([key, value]) => {
            if (["producer", "brand", "root_taxon"].includes(key)) {
              return [`${key}_id`, value];
            }
            return [key, value];
          }),
        ),
      );
    },
  });

  const onSubmit = (values) => update(values);

  return (
    <Dashboard
      header={{
        title: "Podstawowe informacje",
        icon: "info",
      }}
      footer={
        <>
          <Button
            type="save"
            text={is_updating ? "Proszę czekać..." : "Zapisz"}
            disabled={pristine || invalid || is_updating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <Field
          name="name"
          label="Nazwa produktu"
          component={InputField}
          type="text"
        />
        <div className="row m-b-10">
          <div className="box-6">
            <Field name="sku" label="SKU" component={InputField} type="text" />
          </div>
          <div className="box-6">
            <Input
              label="Kategoria"
              input={{
                name: "root_taxon_id",
                disabled: true,
                value: `${product_group?.root_taxon?.name} [${product_group?.root_taxon?.identifier}]`,
              }}
              meta={{}}
            />
          </div>
        </div>
        <div className="row m-b-10">
          <div className="box-6">
            <Input
              label="Producent"
              input={{
                name: "producer_id",
                disabled: true,
                value: product_group?.producer?.name,
              }}
              meta={{}}
            />
          </div>
          <div className="box-6">
            <Input
              label="Marka"
              input={{
                name: "brand_id",
                disabled: true,
                value: product_group?.brand?.name,
              }}
              meta={{}}
            />
          </div>
        </div>
        <div className="row m-b-10">
          <div className="box-6">
            <Field
              name="producer_code"
              label="Kod producenta"
              component={InputField}
              type="text"
            />
          </div>
          <div className="box-6">
            <Field name="ean" label="EAN" component={InputField} type="text" />
          </div>
        </div>
        <div className="row m-b-10">
          <div className="box-6">
            <Field
              label="Status produktu"
              name="status"
              component={SelectField}
              options={product_status_options}
              handleChange={(val) => change("status", val)}
              defaultValue={product_status_options.find(
                ({ value }) => value === initialValues.status,
              )}
            />
          </div>
          <div className="box-6">
            <Field
              label="Produkt jest wirtualny"
              name="is_virtual"
              info="Posida substytucyjne produkty"
              component={CheckField}
              disabled={is_bundle}
            />
          </div>
        </div>
        <div className="row">
          <div className="box-6">
            <Field
              label="Produkt jest bundlem"
              info="Powstaje z kompletacji innych produktów"
              name="is_bundle"
              component={CheckField}
              disabled={is_virtual}
            />
          </div>
          <div className="box-6">
            {product_status === "active" ? (
              <Field
                name="has_infinite_sales_stock"
                label={
                  <>
                    Posiada <strong>nielimitowane</strong> stany
                  </>
                }
                disabled={is_bundle || is_virtual}
                info="Jeśli tak, stany magazynowe nię będą synchronizowane z realnym stanem."
                component={CheckField}
              />
            ) : (
              <div className="form-group">
                <div className="check-group disabled">
                  <input
                    disabled
                    name="has_infinite_sales_stock_readonly"
                    type="checkbox"
                  />
                  <label
                    htmlFor="has_infinite_sales_stock_readonly"
                    className="label-form"
                  >
                    Posiada <strong>nielimitowane</strong> stany
                  </label>
                  <p className="additional-info">
                    Jeśli tak, stany magazynowe nię będą synchronizowane z
                    realnym stanem.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="row">
          <div className="box-6">
            <Field
              label="Mnożnik ceny sugerowanej"
              name="suggested_price_multiplier"
              component={InputField}
            />
          </div>
        </div>
      </form>
    </Dashboard>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "Nazwa produktu jest wymagana!";
  }

  if (!values.sku) {
    errors.sku = "SKU produktu jest wymagane!";
  }

  return errors;
};

const form = "update-product-basic";
const selector = formValueSelector(form);

export default connect((state) => ({
  product_status: selector(state, "status"),
  is_bundle: selector(state, "is_bundle"),
  is_virtual: selector(state, "is_virtual"),
}))(reduxForm({ form, enableReinitialize: true, validate })(BasicData));
